import { SORT_KEYS } from "../FilterAndSort/constants/constants";

export const useDefaultSortKey = () => {
  return SORT_KEYS.DISTANCE_NEAREST;
};
